import React from 'react';

const Vue_Computed = () => {
  return (
    <div>
      <h1>Vue_Computed Component</h1>
      <p>This is the Vue_Computed tutorial page.</p>
    </div>
  );
}

export default Vue_Computed;
